/*
 * The MIT License
 *
 * Copyright (c) 2013, Sebastian Sdorra
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

/**
 * @ngdoc directive
 * @name adf.directive:adfDashboard
 * @element div
 * @restrict EA
 * @scope
 * @description
 *
 * `adfDashboard` is a directive which renders the dashboard with all its
 * components. The directive requires a name attribute. The name of the
 * dashboard can be used to store the model.
 */

(function () {
	'use strict';

	angular.module('adf')
	.service('dashboardService', function($q, $http, hostUrl, addUserDashboardUrl) {
		return {
			addDashboard: addDashboard,
			deleteDashboard: deleteDashboard,
			moveEmptyToEndOfList: moveEmptyToEndOfList,
			reloadPage: reloadPage
		};

		function addDashboard(dashboardData, isRename) {
			var extraQueryParam = '';
			if (dashboardData.parentName === 'Empty') {
				extraQueryParam = '?addDefaultWidgets=false';
			}
			if (isRename) {
				extraQueryParam = extraQueryParam.length ? '&dashboardRename=true' : '?dashboardRename=true';
			}
			var data = {
				name: dashboardData.name,
				parentName: dashboardData.parentName,
				layout: dashboardData.structure,
				config: dashboardData.config,
				filterConfig: dashboardData.filterConfig,
				dashboardName: dashboardData.dashboardName,
				id: dashboardData.id
			};

			if (dashboardData.isEdit) {
				data.id = dashboardData.id;
			}
			var newAddUserDashboardUrl = addUserDashboardUrl + globalConfig.factory.id + '/Dashboard';
			var request = $http({
				method: 'put',
				url: hostUrl + newAddUserDashboardUrl + extraQueryParam,
				data: data
			});
			return (request.then(handleSuccess, handleError));
		}
		function deleteDashboard(dashboardName, dashboardId) {
			var newAddUserDashboardUrl = addUserDashboardUrl + globalConfig.factory.id + '/Dashboard';
			var request = $http({
				method: 'delete',
				url: hostUrl + newAddUserDashboardUrl + '/' + dashboardId
			});
			return (request.then(handleSuccess, handleError));
		}

		function handleError(response) {
			if (!angular.isObject(response.data) ||
				!response.data.message
			) {
				return ($q.reject('An unknown error occurred.'));
			}

			// Otherwise, use expected error message.
			return ($q.reject(response.data.message));
		}
		function handleSuccess(response) {
			return (response.data);
		}

		function moveEmptyToEndOfList(dashboards) {
			var emptyDashboardNdx = -1;
			dashboards = dashboards.filter(function(d) {
				return d.default;
			});
			for (var i = 0; i < dashboards.length; i++) {
				if (dashboards[i].name === 'Empty') {
					emptyDashboardNdx = i;
					break;
				}
			}
			if (emptyDashboardNdx !== -1) {
				var emptyDashboard = dashboards[emptyDashboardNdx];
				dashboards.splice(emptyDashboardNdx, 1);
				dashboards.push(emptyDashboard);
			}
			return dashboards;
		}

		function reloadPage(time) {
			var url = hostUrl + '2/Status';
			return $http.get(url)
				.then(reloadPageSuccess)
				.catch(reloadPageError);

			function reloadPageSuccess(data) {
				location.reload();
			}

			function reloadPageError(error) {
				//do nothing, API catch all should catch this and retry
			}
		}
	});
})();
